<script>
  import { useQuery } from "@sveltestack/svelte-query";
  import superagent from "superagent";
  import request from "superagent";
  import { _ } from "svelte-i18n";

  export let active;
  export let onClose;
  export let alreadyAddedTrainers = [];

  let selectedTrainers = [];
  let canComment = true;
  let sessionConsent = false;
  let menstruationConsent = false;
  let sleepConsent = false;
  let restingPulseConsent = false;
  let showErrorMessage = false;

  const storedUser = localStorage.getItem("user");
  let env;
  let user =
    storedUser !== null
      ? JSON.parse(storedUser)
      : {
          name: "(ditt navn)",
          surname: "",
        };
  let trainerList = [];
  const trainers = useQuery("trainers", () =>
    user.id !== undefined
      ? superagent
          .get("/api/trainers")
          .set("Authorization", "Bearer " + user.id)
          .then((response) => {
            return response.body;
          })
      : undefined
  );

  $: if (!$trainers.isLoading && $trainers.data) {
    trainerList = $trainers.data
      .filter((trainer) => trainer.id !== user.id)
      .map((trainer) => ({
        ...trainer,
        alreadyAdded: alreadyAddedTrainers.includes(trainer.id),
      }));
  }

  function saveToServer(userContent, trainers) {
    const user = userContent !== null ? JSON.parse(userContent).id : undefined;
    if (user !== undefined) {
      console.log("Save trainer access for athlete ", user);
      request
        .post("/api/trainers")
        .set("Content-Type", "application/json")
        .set("Authorization", "Bearer " + user)
        .send(trainers)
        .then((response) => {
          console.log("[INFO] Saved to server");
          onClose();
        })
        .catch((error) =>
          console.log("[ERROR] Not able to save to server, got", error)
        );
    }
  }

  function save() {
    const trainersAndAccess = {
      access: {
        viewSession: sessionConsent,
        viewMenstruation: menstruationConsent,
        viewSleep: sleepConsent,
        viewRestingPulse: restingPulseConsent,
        canComment: canComment,
      },
      trainers: selectedTrainers,
    };
    if (!sessionConsent) {
      showErrorMessage = true;
      return false;
    }
    showErrorMessage = false;
    saveToServer(localStorage.getItem("user"), trainersAndAccess);
    return false;
  }
</script>

{#if active}
  <div class="modal">
    <div class="modal__backdrop"></div>
    <div class="modal__wrapper">
      <div
        class="modal__content"
        style="animation: auto ease 0s 1 normal none running none;"
      >
        <div>
          <header class="modal__header">
            <button on:click={onClose} type="button" class="modal__button-close"
            ></button>
            <h1 class="h2">{$_("profile.access.form.title")}</h1>
          </header>
          <div class="modal__body">
            <form>
              <fieldset class="form-section">
                <label class="input" for="name" style="display: none;"
                  ><label class="input input--search" for="Søk etter person"
                    ><span class="input__label">Søk etter person</span>
                    <div style="display: block;">
                      <input
                        class="input__text"
                        role="combobox"
                        aria-autocomplete="list"
                        aria-expanded="false"
                        autocomplete="off"
                        value=""
                        id="Søk etter person"
                      />
                    </div></label
                  ></label
                >
                <h2 class="h3">
                  {$_("profile.access.form.people")}
                </h2>
                {#each trainerList as trainer, index}
                  <label class="checkbox" for="select-user"
                    ><input
                      type="checkbox"
                      class="checkbox__input-hidden"
                      id="select-user"
                      name="select-user"
                      value="user-selected"
                      checked={selectedTrainers.includes(trainer.id) ||
                        trainer.alreadyAdded}
                      disabled={trainer.alreadyAdded}
                      style="cursor: {trainer.alreadyAdded
                        ? 'not-allowed'
                        : 'pointer'} !important;"
                      on:click={() => {
                        if (
                          selectedTrainers.includes(trainer.id) ||
                          trainer.alreadyAdded
                        ) {
                          selectedTrainers = selectedTrainers.filter(
                            (item) => item !== trainer.id
                          );
                        } else {
                          selectedTrainers = selectedTrainers.concat(
                            trainer.id
                          );
                        }
                      }}
                    /><span
                      class="checkbox__input-custom"
                      style="opacity: {trainer.alreadyAdded ? 0.5 : 1};"
                    ></span><span
                      class="checkbox__label"
                      style="opacity: {trainer.alreadyAdded ? 0.5 : 1};"
                      >{trainer.name} {trainer.surname} - {trainer.club}</span
                    ></label
                  >
                {/each}
                {#if trainerList.length === 0 && !$trainers.isLoading}
                  <p>
                    {$_("profile.form.noTrainers")}
                  </p>
                {/if}
                {#if $trainers.isLoading}
                  <p>{$_("profile.form.loading")}</p>
                {/if}
              </fieldset>
              <fieldset class="form-section" style="">
                <h2 class="h3">{$_("profile.access.form.commentAccess")}</h2>
                <label class="checkbox" for="comment-access"
                  ><input
                    type="checkbox"
                    class="checkbox__input-hidden"
                    id="comment-access"
                    name="comment-access"
                    value="comments-not-visible"
                    bind:checked={canComment}
                  /><span class="checkbox__input-custom"></span><span
                    class="checkbox__label"
                    >{$_("profile.access.form.grantCommentAccess")}</span
                  ></label
                >
              </fieldset>
              <fieldset class="form-section">
                <h2 class="h3">{$_("profile.access.form.consent")}</h2>
                <label class="checkbox" for="sessionConsent"
                  ><input
                    type="checkbox"
                    class="checkbox__input-hidden"
                    id="sessionConsent"
                    name="sessionConsent"
                    value="sessionConsent-not-visible"
                    bind:checked={sessionConsent}
                  /><span class="checkbox__input-custom"></span><span
                    class="checkbox__label"
                    >{$_("profile.access.form.sessionConsent")}</span
                  ></label
                >
                <label class="checkbox" for="menstruationConsent"
                  ><input
                    type="checkbox"
                    class="checkbox__input-hidden"
                    id="menstruationConsent"
                    name="menstruationConsent"
                    value="menstruationConsent-not-visible"
                    bind:checked={menstruationConsent}
                  /><span class="checkbox__input-custom"></span><span
                    class="checkbox__label"
                    >{$_("profile.access.form.menstruationConsent")}</span
                  ></label
                >
                <label class="checkbox" for="sleepConsent"
                  ><input
                    type="checkbox"
                    class="checkbox__input-hidden"
                    id="sleepConsent"
                    name="sleepConsent"
                    value="sleepConsent-not-visible"
                    bind:checked={sleepConsent}
                  /><span class="checkbox__input-custom"></span><span
                    class="checkbox__label"
                    >{$_("profile.access.form.sleepConsent")}</span
                  ></label
                >
                <label class="checkbox" for="restingPulseConsent"
                  ><input
                    type="checkbox"
                    class="checkbox__input-hidden"
                    id="restingPulseConsent"
                    name="restingPulseConsent"
                    value="restingPulseConsent-not-visible"
                    bind:checked={restingPulseConsent}
                  /><span class="checkbox__input-custom"></span><span
                    class="checkbox__label"
                    >{$_("profile.access.form.restingPulseConsent")}</span
                  ></label
                >
                <p>{$_("profile.access.form.consentInfo")}</p>
                <span class="form-error {showErrorMessage ? 'is-visible' : ''}"
                  >{$_("profile.access.form.consentError")}</span
                >
              </fieldset>
              <fieldset class="form-section form-section--submit">
                <div class="layout-buttons layout-buttons--left-right">
                  <button
                    on:click={onClose}
                    type="button"
                    class="button-text button-text--cancel"
                    >{$_("generic.buttons.cancel")}</button
                  ><button
                    on:click={save}
                    type="button"
                    class="button button--icon button--icon-check"
                    >{$_("profile.access.form.submit")}</button
                  >
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}
